  <template>
    <div>
        <div class="col-md-6 ">
            <div v-if="!can_add && !client_being_edited" style="background-color:#FFE98A;padding:10px;margin-bottom:20px;">
                You have used up all available clients for your license type.
            </div>
            <div v-else class="panel panel-default">
                <div class="panel-heading">{{form_title}}</div>

                <div class="panel-body">
                    <tenant-input
                            :user_id="user_id"
                            :client_being_edited="client_being_edited"
                            :can_add="can_add"
                            @updateTenant="updateTenants"
                    />
                </div>
            </div>
        </div>
        <div class="col-md-6 ">
            <el-button v-if="client_being_edited && can_add" type="primary" style="margin-bottom:20px" v-on:click="toggleToSaveForm">Add New Client</el-button>

            <div class="panel panel-default">
                <div class="panel-heading">Existing Clients</div>

                <div class="panel-body">
                    <el-table
                            :data="array_data"
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="id"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="Name"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="state"
                                label="State"
                        >
                            <template slot-scope="scope">
                              <el-tag
                                  :type="scope.row.state_color"
                                  disable-transitions>{{scope.row.state}}</el-tag>
                              <el-popover v-if="scope.row.state==='archiving'"
                                          placement="top-start"
                                          title="Archiving"
                                          width="500"
                                          trigger="hover"
                                          content="Refresh this page to see if the archiving is complete"
                              >
                                <i class="el-icon-info" slot="reference"></i>
                              </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="50"
                        >
                            <template slot-scope="scope">
                                <el-button
                                        size="mini"
                                        type="info"
                                        icon="el-icon-edit"
                                        @click="editTenant(scope.row.id)"></el-button>

                            </template>
                        </el-table-column>
                        <el-table-column
                            width="50"
                        >
                            <template slot-scope="scope">
                                <a :href="'/extents/'+scope.row.id">Info</a>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="40"
                        >
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.singleton_id" @click="go(scope.row.singleton_id)" type="text">Go</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['user_id'],
        mounted() {
            console.log('Component mounted now.')
            this.updateTenants()
        },
        data() {
            return {
                array_data: [{name: 'loading'}],
                client_being_edited: null,
                can_add: false,
                timezone_meta: null,
            }
        },
        computed: {
            form_title: function () {
                if (this.client_being_edited) return "Edit Existing Client"
                return "New Client"
            }
        },
        methods: {
            go(id) {
                axios.post('/extents/current', {
                    current_extent: id
                }).then(response => {
                    window.open('/assets')
                })
                    .catch(error => {
                        console.log('could not set the extent session variable')
                    })
            },
            editTenant(id) {
                console.log(id)
                this.client_being_edited = this.array_data.find(c => c.id === id);
                console.log('in TenantList')
                console.log(this.client_being_edited)
            },
            toggleToSaveForm() {
                this.client_being_edited = null
            },
            updateTenants() {
                console.log('in updateTenants()')
                this.client_being_edited = null
                // FIXME
                // This logic isn't really right. We need to look at the list of *organizations*
                // rather than the list of *clients*. For instance, if we were to add a new
                // organization we would not see it in the tenant list.
                axios.get('/api/tenants/' + this.user_id)
                    .then(response => {
                        this.array_data = response.data
                        if (this.array_data && Array.isArray(this.array_data) && this.array_data.length === 0) {
                            this.can_add = true
                        } else {
                            this.can_add = false
                            this.array_data.forEach((client) => {
                                if (client.remaining && client.remaining.clients > 0) this.can_add = true
                            })
                        }
                        console.log(this.array_data)
                    })
                    .catch(error => {
                        console.log('oops')
                        console.log(error)
                    })
            }
        }
    }
</script>